@if (!isPluginMode()) {
  <mat-toolbar class="header">
    <div class="back" mat-dialog-close matTooltip="Atrás" matTooltipPosition="right">
      <mat-icon >arrow_back_ios_new</mat-icon>
    </div>
    <div>
      Editar {{ "financial_movement" | human}}
    </div>
  </mat-toolbar>
}

<div [ngClass]="{'dialog-wrapper': !isPluginMode()}">
  <div #wrapper>
    <form [formGroup]="form">
      @if (!_hideClientSelection) {
        <section>
          <div class="subtitle">Cliente</div>
          <div class="form-row">
            <mat-form-field class="field">
              <mat-label>Tipo de Cliente</mat-label>
              <mat-select formControlName="party_type">
                <mat-option value="Client">{{'client' | human}}</mat-option>
                <mat-option value="Provider">{{ 'provider' | human }}</mat-option>
              </mat-select>
            </mat-form-field>
            @if (form.get("party_type").value) {
              @switch (form.get("party_type").value) {
                @case('Client') {
                  <app-client-select
                    formControlName="party_id"
                    (onload)="onClientLoad($event)"
                  >
                  </app-client-select>
                }
                @case('Provider') {
                  <app-provider-select
                    formControlName="party_id"
                    (onload)="onClientLoad($event)"
                  >
                  </app-provider-select>
                }
              }
            }
          </div>
        </section>
      }
      
      <section>
        <div class="subtitle">Pago</div>
        <mat-radio-group [(ngModel)]="alreadyPayed" [ngModelOptions]="{standalone: true}">
          <mat-radio-button class="radio-button" [value]="true">
            Pago inmediato
          </mat-radio-button>
          <mat-radio-button class="radio-button" [value]="false">
            Por pagar
          </mat-radio-button>
        </mat-radio-group>
        <div class="form-row">
          <mat-form-field class="field">
            <mat-label>{{ 'payment_method' | human }}</mat-label>
            <mat-select 
              aria-label="Método de Pago"
              formControlName="payment_method"  
            >
              <mat-option value="cash">Efectivo</mat-option>
              <mat-option value="credit_card">Tarjeta de Crédito</mat-option>
              <mat-option value="debit_card">Tarjeta de Débito</mat-option>
              <mat-option value="transfer">Transferencia</mat-option>
              <mat-option value="cheque">Cheque</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Monto {{ alreadyPayed() ? 'Pagado' : 'a Pagar' }}</mat-label>
            <input matInput currencyMask formControlName="amount">
          </mat-form-field>
          <mat-form-field>
            <mat-label>Fecha de Pago</mat-label>
            <input matInput [matDatepicker]="due_date" formControlName="due_date">
            <mat-datepicker-toggle matSuffix [for]="due_date"></mat-datepicker-toggle>
            <mat-datepicker #due_date></mat-datepicker>
          </mat-form-field>
          @if (shouldEnterReceiptNumber) {
            <mat-form-field>
              <mat-label>Número Comprobante de Pago</mat-label>
              <input matInput [formControl]="form.get('extra_params.reference_number') | formGroup">
            </mat-form-field>
          }
        </div>
      </section>

      <section>
        <div class="form-row note-input">
          <mat-form-field appearance="fill">
            <mat-label>Nota</mat-label>
            <textarea matInput [formControl]="form.get('notes') | formGroup"></textarea>
          </mat-form-field>
        </div>
      </section>
    </form>
  </div>
</div>

@if (!isPluginMode()) {
  <mat-toolbar class="footer">
    <button mat-raised-button mat-dialog-close> 
      Cancelar
    </button>
    <div class="expander"></div>
    <button mat-raised-button
            type="button"
            color="primary"
            [disabled]="!formValid || loading()"
            (click)="saveForm()">
      @if (loading()) {
        <mat-spinner diameter="30"></mat-spinner>
      } @else {
        Guardar
      }
    </button>
  </mat-toolbar>
}
